import {
  GET_NOTIFICATIONS_ASYNC,
  RESTORE_NOTIFICATIONS_ASYNC,
  UPDATE_NOTIFICATIONS_ASYNC,
} from './constants'

export const getNotifications = (locale) => ({
  type: GET_NOTIFICATIONS_ASYNC.INITIATE,
  payload: { locale },
})
const getNotificationsCancel = () => ({ type: GET_NOTIFICATIONS_ASYNC.CANCEL })
export const getNotificationsSuccess = (data) => ({
  type: GET_NOTIFICATIONS_ASYNC.SUCCESS,
  payload: { data },
})
export const getNotificationsError = (error) => ({
  type: GET_NOTIFICATIONS_ASYNC.ERROR,
  error,
})

const updateNotifications = (notifications, coPilot, locale) => ({
  type: UPDATE_NOTIFICATIONS_ASYNC.INITIATE,
  payload: { data: { ...notifications, themis_co_pilot: coPilot }, locale },
})
const updateNotificationsCancel = () => ({
  type: UPDATE_NOTIFICATIONS_ASYNC.CANCEL,
})
export const updateNotificationsSuccess = () => ({
  type: UPDATE_NOTIFICATIONS_ASYNC.SUCCESS,
})
export const updateNotificationsError = (error) => ({
  type: UPDATE_NOTIFICATIONS_ASYNC.ERROR,
  error,
})

const restoreNotifications = (locale) => ({
  type: RESTORE_NOTIFICATIONS_ASYNC.INITIATE,
  payload: { locale },
})
export const restoreNotificationsSuccess = () => ({ type: RESTORE_NOTIFICATIONS_ASYNC.SUCCESS })
export const restoreNotificationsError = (error) => ({
  type: RESTORE_NOTIFICATIONS_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getNotifications,
  getNotificationsCancel,
  updateNotifications,
  updateNotificationsCancel,
  restoreNotifications,
}
